import { render } from "./footer-com.vue?vue&type=template&id=54a457d6&scoped=true"
import script from "./footer-com.vue?vue&type=script&lang=js"
export * from "./footer-com.vue?vue&type=script&lang=js"

import "./footer-com.vue?vue&type=style&index=0&id=54a457d6&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a457d6"]])

export default __exports__